var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[(true)?_c('sample'):_c('h3',[_vm._v("\n      Thanks for signing in and feeling out our form. We are processing your\n      submission\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }